export interface IHisInformationValue {
  key: string;
  data: string[] | Date[];
}

export class HisInformationTextValue implements IHisInformationValue {
  constructor(public key: string, public data: string[]) {}
}

export class HisInformationDateTimeValue implements IHisInformationValue {
  constructor(public key: string, public data: Date[], public format?: string) {}
}
